import ApiClient from './ApiClient'

export default class EnruiryService {

  constructor() {
      this.apiClient = new ApiClient()
  }

  submitEnquiry(enquiry) {
    return this.apiClient.create().post('enquiry', enquiry)
  }

  get() {
    return this.apiClient.createAuthed().get('enquiry')
  }

  getNumberOfUnseenEnquiries() {
    return this.apiClient.createAuthed().get('enquiry/getnumberofunseenenquiries')
  }

  deleteEnquiry(enquiryId) {
    return this.apiClient.createAuthed().delete(`enquiry/${enquiryId}`)
  }

  sendTestEnquiry() {
    return this.apiClient.createAuthed().post('enquiry/sendtestenquiry')
  }

}